import { render, staticRenderFns } from "./CatalogPage.vue?vue&type=template&id=f82f24a0&scoped=true"
import script from "./CatalogPage.vue?vue&type=script&lang=js"
export * from "./CatalogPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82f24a0",
  null
  
)

export default component.exports